import {type ContextType} from '@packages/systems/wfdl';
import {List} from 'immutable';

export const maybeAddOpen =
  (context: ContextType) => (openClass: string) => (classes: List<string>) =>
    context.get('isOpen') === true ? classes.push(openClass) : classes;
